import { render, staticRenderFns } from "./CommonReportTab.vue?vue&type=template&id=03f6d2d3&scoped=true"
import script from "./CommonReportTab.vue?vue&type=script&lang=ts"
export * from "./CommonReportTab.vue?vue&type=script&lang=ts"
import style0 from "./CommonReportTab.vue?vue&type=style&index=0&id=03f6d2d3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f6d2d3",
  null
  
)

export default component.exports